import "./Navbar.css";

export default function Navbar({ onToggleWishlist }) {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        💘 <span className="logo-text">PleasedateMyFriends.com</span>
      </div>
      <div className="navbar-links">
        <button className="wishlist-toggle" onClick={onToggleWishlist}>
          ❤️ Wishlist
        </button>
      </div>
    </nav>
  );
}
